import { render, staticRenderFns } from "./RelaySelectConnectedBox.vue?vue&type=template&id=83fcbb9c&"
import script from "./RelaySelectConnectedBox.vue?vue&type=script&lang=ts&"
export * from "./RelaySelectConnectedBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports